// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"fb4c7507","563":"63beb93c"}[chunkId] + ".chunk.js";
};